import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contact-form"
export default class extends Controller {
  static targets = []

  addCircleToField(event) {
    const button = event.currentTarget;
    const circleName = button.dataset.circleName;
    const circleField = document.querySelector('input[name="contact[circle_names]"]');

    if (!circleField) return;

    let currentValue = circleField.value.trim();

    // Check if circle is already added
    const currentCircles = currentValue ? currentValue.split(',').map(c => c.trim()) : [];
    if (currentCircles.includes(circleName)) {
      return; // Circle already added
    }

    // Add circle to the field
    if (currentValue) {
      circleField.value = currentValue + ', ' + circleName;
    } else {
      circleField.value = circleName;
    }

    // Visual feedback
    this.showFeedback(button, 'success');
  }

  addTagToField(event) {
    const button = event.currentTarget;
    const tagName = button.dataset.tagName;
    const tagField = document.querySelector('input[name="contact[tag_names]"]');

    if (!tagField) return;

    let currentValue = tagField.value.trim();

    // Check if tag is already added
    const currentTags = currentValue ? currentValue.split(',').map(t => t.trim()) : [];
    if (currentTags.includes(tagName)) {
      return; // Tag already added
    }

    // Add tag to the field
    if (currentValue) {
      tagField.value = currentValue + ', ' + tagName;
    } else {
      tagField.value = tagName;
    }

    // Visual feedback
    this.showFeedback(button, 'info');
  }

  showFeedback(button, type) {
    const originalClasses = button.className;
    
    if (type === 'success') {
      button.classList.add('circle-tag--selected');
    } else if (type === 'info') {
      button.classList.add('tag-suggestion--selected');
    }

    setTimeout(() => {
      button.className = originalClasses;
    }, 1000);
  }
}